import {
  report,
  reportGlobalTags,
  reportIdentify,
  reportInit,
} from "@chatfood/bug-reporter";
import type { BugReporterService } from "../types";
import { useNuxtApp } from "#imports";

export class ClientService implements BugReporterService {
  report(...args: Parameters<typeof report>) {
    const [error, params] = args;

    const nuxtApp = useNuxtApp();

    const opts: Parameters<typeof report>[1] = {
      tags: params?.tags,
      extra: params?.extra ?? params?.context,
      state: JSON.parse(JSON.stringify(nuxtApp.$pinia.state.value)),
    };

    report(error, opts);
  }

  reportGlobalTags(...args: Parameters<typeof reportGlobalTags>) {
    reportGlobalTags(...args);
  }

  reportIdentify(...args: Parameters<typeof reportIdentify>) {
    reportIdentify(...args);
  }

  reportInit(...args: Parameters<typeof reportInit>) {
    reportInit(...args);
  }
}
